import React from 'react';
import {
    TextField,
    Button,
    IconButton,
    Typography,
    Box,
    FormControl,
    InputLabel,
    OutlinedInput,
    InputAdornment,
} from "@mui/material";
import Grid from "@mui/system/Grid";
import Stack from "@mui/system/Stack";
import { Link } from 'react-router-dom';




const AgreeSec = () => {
    return (
        <Box sx={{ position: 'absolute', bottom: { xs: '4px', xl: '24px' }, left: 0, right: 0, }}>
            <Box sx={{ borderTop: '1px solid #1B2338', width: { xs: '100%', xl: '83%' }, margin: '0 auto', p: { xs: '4px', xl: '12px' } }}>
                <Typography sx={{ color: '#CBD2E2', textAlign: 'center', cursor: 'pointer', fontSize: '16px', fontWeight: '400', mb: { xs: '2px', xl: '8px' } }}>
                    By creating an account you agree to our
                </Typography>
                <Stack direction={'row'} justifyContent={'center'} alignItems={'center'}>
                    <Typography sx={{ color: '#84A1D6', textAlign: 'center', cursor: 'pointer', fontSize: { xs: '12px', xl: '16px' }, fontWeight: '400', borderRight: '1px solid #2E3852', pr: '12px', mr: '12px' }}  component={Link}
                    to="/terms">
                        Terms of use
                    </Typography>
                    <Typography sx={{ color: '#84A1D6', textAlign: 'center', cursor: 'pointer', fontSize: { xs: '12px', xl: '16px' }, fontWeight: '400' }} component={Link} to="/privacy">
                        Privacy policy
                    </Typography>
                </Stack>
            </Box>
        </Box>
    );
};

export default AgreeSec;

